import axios from "axios";
import jwtDecode from "jwt-decode";
import FuseUtils from "@fuse/FuseUtils";
import Host from "../Host";
import history from "@history";

class jwtService extends FuseUtils.EventEmitter {
	init() {
		this.setInterceptors();
		this.handleAuthentication();
	}

	setInterceptors = () => {
		axios.interceptors.response.use(
			(response) => {
				return response;
			},
			(err) => {
				return new Promise((resolve, reject) => {
					if (
						err.response?.status === 401 &&
						err.config &&
						!err.config.__isRetryRequest
					) {
						// if you ever get an unauthorized response, logout the user
						this.emit("onAutoLogout", "Invalid access_token");
						this.setSession(null);
					}
					throw err;
				});
			}
		);
	};

	handleAuthentication = () => {
		let access_token = this.getAccessToken();

		if (!access_token) {
			history.push("/login");
			return;
		}

		if (this.isAuthTokenValid(access_token)) {
			this.setSession(access_token);
			this.emit("onAutoLogin", true);
		} else {
			this.setSession(null);
			this.emit("onAutoLogout", "access_token expired");
		}
	};

	createUser = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(Host + "/auth/register", data)
				.then((response) => {
					if (response.data.user) {
						this.setSession(response.data.access_token);
						resolve(response.data.user);
					} else {
						reject(response.data.error);
					}
				})
				.catch((error) => {
					console.log("error: ", error.response);
					let errorResponse = {};
					if (error.response?.status === 500) {
						errorResponse.nickname = "이미 등록된 닉네임입니다.";
					} else {
						errorResponse.email = "이미 등록된 이메일입니다.";
					}
					reject(errorResponse);
				});
		});
	};

	signInWithEmailAndPassword = (email, password) => {
		return new Promise((resolve, reject) => {
			axios
				.post(Host + "/auth/login", {
					email,
					password,
				})
				.then((response) => {
					if (response.data.user) {
						this.setSession(response.data.token);
						resolve(response.data.user);
					} else {
						reject(response.data.error);
					}
				});
		});
	};

	signInWithToken = () => {
		return new Promise((resolve, reject) => {
			axios
				.post(Host + "/auth/jwtLogin", {
					data: {
						access_token: this.getAccessToken(),
					},
				})
				.then((response) => {
					if (response.data.user) {
						this.setSession(response.data.token);
						resolve(response.data.user);
					} else {
						reject(response.data.error);
					}
				});
		});
	};

	updateUserData = (user) => {
		return axios.put(Host + "/user/" + user.id, user);
	};

	setSession = (access_token) => {
		// console.log("access_token: ", access_token);
		if (access_token) {
			window.localStorage.setItem("jwt_access_token", access_token);
			axios.defaults.headers.common["Authorization"] = access_token;
		} else {
			window.localStorage.removeItem("jwt_access_token");
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	logout = () => {
		this.setSession(null);
	};

	isAuthTokenValid = (access_token) => {
		if (!access_token) {
			return false;
		}
		const decoded = jwtDecode(access_token);
		const currentTime = Date.now() / 1000;
		if (decoded.exp < currentTime) {
			console.warn("access token expired");
			return false;
		} else {
			return true;
		}
	};

	getAccessToken = () => {
		return window.localStorage.getItem("jwt_access_token");
	};
}

const instance = new jwtService();

export default instance;
